'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CustomFilter = require('./filters/CustomFilter');

var _CustomFilter2 = _interopRequireDefault(_CustomFilter);

var _ExactFilter = require('./filters/ExactFilter');

var _ExactFilter2 = _interopRequireDefault(_ExactFilter);

var _RangeFilter = require('./filters/RangeFilter');

var _RangeFilter2 = _interopRequireDefault(_RangeFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sieve = (function () {
  function Sieve() {
    _classCallCheck(this, Sieve);

    this._filters = [];
    this._key = '';
  }

  _createClass(Sieve, [{
    key: 'add',
    value: function add(id, options) {
      if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
        throw new Error('Filter options is not an object');
      }

      if (options.type === undefined) {
        throw new Error('Filter type is not provided');
      }

      if (this._filters[id] !== undefined) {
        throw new Error('The filter \'' + id + '\' already exists');
      }

      switch (options.type) {
        case 'custom':
          this._filters[id] = new _CustomFilter2.default(id, options);
          break;
        case 'exact':
          this._filters[id] = new _ExactFilter2.default(id, options);
          break;
        case 'range':
          this._filters[id] = new _RangeFilter2.default(id, options);
          break;
        default:
          throw new Error('The filter type \'' + options.type + '\' is unknown');
      }

      return this;
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      if (id === undefined) {
        throw new Error('No filter id provided to remove');
      } else if (typeof id !== 'string') {
        throw new Error('Filter id \'' + id + '\' is not a string');
      }

      if (this._filters[id] === undefined) {
        throw new Error('The filter \'' + id + '\' does not exists');
      }

      // remove filter
      delete this._filters[id];

      return this;
    }
  }, {
    key: 'key',
    value: function key(_key) {
      if (!_key) {
        return this._key;
      }
      if (typeof _key !== 'string') {
        throw new Error('Filters key \'' + _key + '\' is not a string');
      }
      this._key = _key;

      return this;
    }
  }, {
    key: 'sift',
    value: function sift(data, inputValues) {
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
        throw new Error('Set filters data is not an array');
      }

      // nothing to filter on
      if (this._filters === [] || inputValues === undefined || Object.keys(inputValues).length === 0) {
        return data;
      }

      if ((typeof inputValues === 'undefined' ? 'undefined' : _typeof(inputValues)) !== 'object') {
        throw new Error('Filters input is not an object');
      }

      var filteredData = data.filter((function (current) {
        var pass = true;
        var obj = current;
        if (this._key !== '') {
          obj = this._key.split('.').reduce(function (o, x) {
            return o[x];
          }, current);
        }

        // Check all filters to see if they will act on each input
        Object.keys(this._filters).every((function (key) {
          var _filter = this._filters[key];

          pass = _filter.filter(obj, inputValues);

          return pass;
        }).bind(this));

        return pass;
      }).bind(this));

      return filteredData;
    }
  }]);

  return Sieve;
})();

exports.default = Sieve;
//# sourceMappingURL=Sieve.js.map